import { defineAgenda, param } from '@/shared/navigation/core';

export const columbusAgenda = defineAgenda({
  id: 'app.columbus-planner',
  path: 'app/columbus-planner',
  open: {},
  state: {
    activeNodeId: param.string().optional(),
    transportType: param.enum(['Air', 'Bus'] as const).optional(),
    includeHistory: param.boolean().optional(),
  },
  title: 'Yield & Ticketing',
  icon: 'map',
  presentationHints: {
    shell: {
      // Strom vlevo, detail vpravo. Do pravého panelu jde vrstva se `zone: 'detail'`
      // (razítkuje ji `openDetail` = výběr ve stromu), ne agenda vyjmenovaná v konfiguraci.
      layoutMode: 'list-detail',
    },
  },
});
